var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.38,
    height: 10.785,
    viewBox: "0 0 14.38 10.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1383",
    "data-name": "Groupe 1383",
    transform: "translate(-1200.915 -325.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_314",
    "data-name": "Groupe 314",
    transform: "translate(1200.915 325.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_312",
    "data-name": "Groupe 312",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279",
    "data-name": "Trac\\xE9 279",
    d: "M7.191,14.785A7.793,7.793,0,0,1,.03,9.554a.449.449,0,0,1,0-.323A7.793,7.793,0,0,1,7.191,4a7.793,7.793,0,0,1,7.16,5.231.449.449,0,0,1,0,.323A7.793,7.793,0,0,1,7.191,14.785ZM.933,9.393a6.879,6.879,0,0,0,6.257,4.494,6.879,6.879,0,0,0,6.257-4.494A6.879,6.879,0,0,0,7.191,4.9,6.879,6.879,0,0,0,.933,9.393Z",
    transform: "translate(0 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_313",
    "data-name": "Groupe 313",
    transform: "translate(4.494 2.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280",
    "data-name": "Trac\\xE9 280",
    d: "M12.7,10a2.7,2.7,0,1,0,2.7,2.7A2.7,2.7,0,0,0,12.7,10Zm-.9,2.795a.9.9,0,1,1,.9-.9A.9.9,0,0,1,11.8,12.795Z",
    transform: "translate(-10 -10)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1860f7165bb0cb0ed6276812da89a3b6.svg";
export { ForwardRef as ReactComponent };